import { Component, OnInit } from '@angular/core';
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {FormaDePagamento} from "../../pedidos/objetos/FormaDePagamento";
import {EditEvent, GridDataResult, RemoveEvent} from "@progress/kendo-angular-grid";
import {DialogService} from "@progress/kendo-angular-dialog";
import {NovaFormaDePagamentoComponent} from "../nova-forma-de-pagamento/nova-forma-de-pagamento.component";
import {FormasDePagamentoService} from "../../services/formas-de-pagamento.service";
import { GroupDescriptor, DataResult, process } from '@progress/kendo-data-query';

@Component({
  selector: 'app-cadastro-formas-de-pagamento',
  templateUrl: './cadastro-formas-de-pagamento.component.html',
  styleUrls: ['./cadastro-formas-de-pagamento.component.scss']
})
export class CadastroFormasDePagamentoComponent implements OnInit {
  loading: any;
  empresa: any;
  formasDePagamento: Array<FormaDePagamento>
  public gridDataResult: GridDataResult;
  carregando: any;
  modalDeletar = false;
  filtro: any;
  formaApagar: FormaDePagamento;

  public groups: GroupDescriptor[] = [{ field: 'tipoDePagamento' }];

  constructor(private constantsService: ConstantsService, private dialogService: DialogService,
              private formasDePagamentoService: FormasDePagamentoService) { }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) return;

      this.empresa = empresa;

      this.formasDePagamentoService.obtenhaFormasDePagamentos(this.empresa).then( (formas) => {
        this.formasDePagamento = formas;

        for( let forma of this.formasDePagamento ) {
          if(forma.nome === 'cashback')
            forma.tipoDePagamento = 'Fidelidade'
          else
            forma.tipoDePagamento = forma.online ? 'Pagamento Online' : 'Pagamento Na Entrega';
        }

        this.gridDataResult = process(this.formasDePagamento, { group: this.groups });
      });
    });
  }

  editar($event: EditEvent) {
    const forma: FormaDePagamento = $event.dataItem;

    let altura = window.innerHeight - 100;

    const windowRef = this.dialogService.open({
      title: 'Cadastro de Forma de Pagamento',
      content: NovaFormaDePagamentoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaNovaFormaDePagamento: NovaFormaDePagamentoComponent = windowRef.content.instance;

    telaNovaFormaDePagamento.windowRef = windowRef;
    telaNovaFormaDePagamento.editar(forma, this.empresa);

    windowRef.result.subscribe((result: any) => {
      this.constantsService.recarregueEmpresa();
    });
  }

  abraDialogRemover($event: RemoveEvent) {
    this.formaApagar = $event.dataItem;

    this.modalDeletar = true;
  }

  onFilter($event: Event) {

  }

  novo(pagamentoOnline: boolean) {
    let altura = window.innerHeight - 100;

    const windowRef = this.dialogService.open({
      title: 'Cadastro de Forma de Pagamento',
      content: NovaFormaDePagamentoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaNovaFormaDePagamento: NovaFormaDePagamentoComponent = windowRef.content.instance;
    telaNovaFormaDePagamento.novaForma(pagamentoOnline, this.empresa);
    telaNovaFormaDePagamento.windowRef = windowRef;

    windowRef.result.subscribe((result: any) => {
      this.constantsService.recarregueEmpresa();
    });
  }

  close(status: string) {
    if( status === 'sim') {
      this.formasDePagamentoService.removaFormaDePagamento(this.formaApagar).then( () => {
        this.constantsService.recarregueEmpresa();
        this.formaApagar = null;
        this.modalDeletar = false;
      });
    } else {
      this.formaApagar = null;
      this.modalDeletar = false;
    }
  }
  temTaxaRetorno(){
    return this.empresa && this.empresa.formasDeEntrega.find((item) => item.taxaExtraRetorno) != null
  }
}
